// import axios from '../../axios';
import apiService from '../../apiService'
import {
  IFileListParams,
  IFileDetail,
  IUploadFilesParams,
  IKnowledgeBase,
  IUserAuthInfo,
  IKnowledgeBaseCapacity,
} from './index.d'
import UserStore from '@stores/UserStore'
import { apiConstants, OperateType, generalApiPrefix } from '@const'
import { getApiUrl } from '@utils'

// 内外网权限问题需要使用api固定域名
const url = `${getApiUrl()}${generalApiPrefix}/knowledgeBase`

export default {
  /** 分类树 */
  getListCategory: () =>
    apiService.get(`${url}/listCategory.do`, { pageId: UserStore.homeId }),
  /**
   * 首页文库列表
   */
  getHomePageKnowledgebase: (): Promise<ISuccessModel<IKnowledgeBase[]>> =>
    apiService.get(
      `${url}/getHomePageKnowledgebase.do`,
      {},
      { withGlobalLoading: true }
    ),
  /**
   * 首页文库容量
   */
  getHomePageKnowledgeCapacity: (): Promise<
    ISuccessModel<IKnowledgeBaseCapacity>
  > => apiService.get(`${url}/capacity.do`, {}),
  /**
   * 文库浏览上报接口
   */
  uploadBrowseRecord: (knowledgeBaseId: string) =>
    apiService.get(
      `${url}/uploadBrowseRecord.do`,
      { knowledgeBaseId },
      { notShowErr: true }
    ),
  /**
   * 首页最新上传列表
   */
  getPageLatest: (): Promise<ISuccessModel<IPageModel<IFileDetail>>> =>
    apiService.get(`${url}/file/page.do`, {
      pageNo: 1,
      pageSize: 5,
      sortField: 'createdDate',
      sortOrder: 'descend',
      noInterceptorCancel: true,
    }),
  /**
   * 首页热门文件列表
   */
  getPagePopular: (): Promise<ISuccessModel<IPageModel<IFileDetail>>> =>
    apiService.get(`${url}/file/page.do`, {
      pageNo: 1,
      pageSize: 5,
      sortField: 'praiseNum',
      sortOrder: 'descend',
      noInterceptorCancel: true,
    }),
  /**
   * 点赞
   */
  praise: (fileId: string) =>
    apiService.get(`${url}/file/praise.do`, { fileId }),
  /** 查看文件 */
  browse: (fileId: string) =>
    apiService.get(
      `${url}/file/browse.do`,
      { fileId },
      { withGlobalLoading: true }
    ),

  /**
   * 全部文库接口-分页
   */
  getKnowledgebaseAll: ({
    knowledgeName,
    operateType,
    pageNo,
    categoryIds,
    pageSize = 10,
    excludeId,
  }: {
    knowledgeName: string
    operateType: number
    pageNo: number
    categoryIds?: any
    pageSize?: number
    excludeId?: string
  }): Promise<ISuccessModel<IPageModel<IKnowledgeBase>>> => {
    return apiService.post(`${url}/getKnowledgebaseAll.do`, {
      knowledgeName,
      operateType,
      pageNo,
      categoryIds,
      pageSize,
      excludeId,
    })
  },

  /**
   * 复制文件
   */
  copyFile: ({
    targetFolderId,
    newFileIds,
    knowledgeBaseId,
    newfolderIds,
  }: {
    newFileIds: string[]
    knowledgeBaseId: string
    newfolderIds: string[]
    targetFolderId: string
  }): Promise<any> => {
    return apiService.post(`${url}/file/copy.do`, {
      fileIds: newFileIds,
      knowledgeBaseId,
      folderIds: newfolderIds,
      targetFolderId,
    })
  },

  /**
   * 转移文件
   */
  moveFile: ({
    newFileIds,
    knowledgeBaseId,
    newfolderIds,
    targetFolderId,
  }: {
    newFileIds: string[]
    knowledgeBaseId: string
    newfolderIds: string[]
    targetFolderId: string
  }): Promise<any> => {
    return apiService.post(`${url}/file/move.do`, {
      fileIds: newFileIds,
      knowledgeBaseId,
      folderIds: newfolderIds,
      targetFolderId,
    })
  },

  /**
   * 删除文件
   */
  deleteFiles: ({
    newFileIds,
    knowledgeBaseId,
    newfolderIds,
  }: {
    newFileIds: string[]
    knowledgeBaseId: string
    newfolderIds: string[]
  }): Promise<any> => {
    return apiService.post(`${url}/file/delete.do`, {
      fileIds: newFileIds,
      knowledgeBaseId,
      folderIds: newfolderIds,
    })
  },

  /**
   * 文件列表
   */
  getFileList: (
    params: IFileListParams
  ): Promise<ISuccessModel<IPageModel<IFileDetail>>> => {
    return apiService.get(`${url}/file/page.do`, {
      ...params,
      pageSize: params.pageSize || 10,
      knowledgeBaseDetail: params.knowledgeBaseDetail || false,
      folderId: params.folderId || '',
    })
  },

  /**
   * 下载文件
   */
  downloadFiles: (
    newFileIds: string[],
    knowledgeBaseName: string,
    newfolderIds?: string[]
  ) => {
    const fileIdsStr = newFileIds.join(',')
    const folderIdsStr = newfolderIds ? newfolderIds.join(',') : ''
    const baseName = encodeURIComponent(knowledgeBaseName)
    window.open(
      `${url}/file/download.do?fileIds=${fileIdsStr}&folderIds=${folderIdsStr}&knowledgeBaseName=${baseName}&sid=${UserStore.sid}&appDevicePlatform=${apiConstants.STR_OS}`
    )
  },

  /**
   * 确认上传文件
   */
  confirmUploadFile: (params: IUploadFilesParams): Promise<any> => {
    return apiService.post(`${url}/file/convertFile.do`, params)
  },
  /**
   * 是否有某一权限的文库
   */
  findAnyKnowlegebaseWithAuth: (operateType: number) =>
    apiService.get(`${url}/findAnyKnowlegebaseWithAuth.do`, {
      operateType,
    }),
  /**
   * 查询文库权限接口
   */
  checkKnowledgebaseAuth: (operateType: number, knowledgeBaseId: string) =>
    apiService.get(`${url}/checkKnowledgebaseAuth.do`, {
      operateType,
      knowledgeBaseId,
    }),
  /**
   * 判断文库权限和是有本人上传的文件
   */
  getUserAuthInfo: (
    knowledgeBaseId: string
  ): Promise<ISuccessModel<IUserAuthInfo>> =>
    apiService.get(`${url}/getUserAuthInfo.do`, {
      knowledgeBaseId,
    }),

  /**
   * 知识库信息
   */
  getKnowledgebaseInfo: (
    knowledgeBaseId: string
  ): Promise<ISuccessModel<IKnowledgeBase>> =>
    apiService.get(`${url}/getKnowledgebaseInfo.do`, {
      knowledgeBaseId,
    }),

  /**
   * 文件上传下载校验权限
   */
  checkFileAuth: (
    operateType: OperateType,
    fileIds?: string[],
    folderIds?: string[]
  ): Promise<ISuccessModel<any>> => {
    const fileIdsStr = fileIds ? fileIds.join(',') : ''
    const folderIdsStr = folderIds ? folderIds.join(',') : ''
    return apiService.get(`${url}/checkFileAuth.do`, {
      // 操作类型1上传,2下载,3删除4复制5转移
      operateType,
      fileIds: fileIdsStr,
      folderIds: folderIdsStr,
    })
  },

  // 查询浏览人数列表
  fetchViewList: (
    fileId: string,
    pageNo: number
  ): Promise<ISuccessModel<any>> => {
    return apiService.get('clientapi/knowledgeBase/file/browsePageList.do', {
      fileId,
      pageNo,
      pageSize: 20,
    })
  },

  /**
   * 动态获取上传接口url
   */
  getUploadUrl: (): Promise<ISuccessModel<string>> =>
    apiService.get(`${url}/file/getUploadUrl.do`),

  // 查询子文件夹/文件接口url
  getFileNodeList: (id: string): Promise<ISuccessModel<any>> => {
    return apiService.get('clientapi/knowledgeBase/folderList.do', {
      id,
    })
  },

  // 根据folderId查询全路径及其全路径id
  getFullPathByFolderId: (folderId: string): Promise<ISuccessModel<any>> => {
    return apiService.get(
      '/clientapi/knowledgeBase/file/queryFullPathByFolderId.do',
      {
        folderId,
      }
    )
  },
}
